import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import classes from './restoreLogDialog.module.scss';
import { ReactComponent as FillClose } from '../../../assets/images/fillClose.svg';
import { ReactComponent as Close } from '../../../assets/images/close.svg';

const useStyles = makeStyles({
  root: {
    background: '#FF7221',
    borderRadius: 0,
    width: 180,
    height: 50,
    color: 'white',
    textTransform: 'none',
    fontWeight: 550,
    fontFamily: 'HelveticaNeueCyr',
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    fontSize: 16,
    marginLeft: 10,
    '&:hover, &:focus': {
      background: '#DE6109',
    },
  },
  restore: {
    fontWeight: 550,
    background: 'white',
    width: 180,
    height: 50,
    fontSize: 16,
    fontFamily: 'HelveticaNeueCyr',
    color: '#FF7221',
    border: '1px solid #FF7221',
    borderRadius: 0,
    marginRight: 10,
    textTransform: 'none',
    '&:hover, &:focus': {
      background: '#DE6109',
      color: 'white',
      border: 'none',
    },
  },
});

type Props = {
  // id: number;
  // handleBlock(id: number): void;
  handleClose(): void;
  open: boolean;
  selectId: number;
  handleRestore(id: number): void;
  handleUpdateEntity?(entityId: number, type: number): Promise<void>;
};

export const RestoreLogDialog = ({
  handleClose,
  open,
  selectId,
  handleRestore,
  handleUpdateEntity,
}: Props) => {
  const [focus, setFocus] = useState(false);

  const style = useStyles();

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        // fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <div className={classes.dialog__dialogTitle}>
            <span>Восстановление</span>
            <div
              className={classes.close}
              onMouseOver={(e) => setFocus(true)}
              onMouseOut={(e) => setFocus(false)}
              onClick={(e) => handleClose()}
            >
              {focus ? <FillClose /> : <Close />}
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className={classes.dialog__question}>
            Вы уверены, что хотите восстановить?
          </div>

          <div className={classes.dialog__buttons}>
            <Button className={style.restore} onClick={handleClose}>
              Отмена
            </Button>
            <Button
              className={style.root}
              onClick={() => {
                handleRestore(selectId);
              }}
            >
              Восстановить
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
